import { pageRepository } from "~/utils/repositories/page"
import { contentRepository } from "~/utils/repositories/content"
import { jobShopRepository } from "~/utils/repositories/jobshop"
import { searchAndFiltersRepository } from "~/utils/repositories/searchAndFilters"
import { typesenseRepository } from "~/utils/repositories/typesense"
import { jobPageTemplateRepository } from "~/utils/repositories/jobPageTemplate"
import { jobRepository } from "~/utils/repositories/job"
import { formRepository } from "~/utils/repositories/form"
import { applicationRepository } from "~/utils/repositories/application"

/**
 * Provides the api repositories created in ~/utils/repositories as a plugin.
 * The plugin is usable via $api.{repository} when imported from useNuxtApp().
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { app: { baseURL } } = useRuntimeConfig()

  // Add general, additional config to the fetch instance used for the api repositories
  const api = $fetch.create({
    baseURL,
  })

  // Add new repositories here
  const repositories = {
    page: pageRepository(api),
    content: contentRepository(api),
    jobShop: jobShopRepository(api),
    searchAndFilters: searchAndFiltersRepository(api),
    typesense: typesenseRepository(api),
    jobPageTemplate: jobPageTemplateRepository(api),
    job: jobRepository(api),
    form: formRepository(api),
    application: applicationRepository(api),
  }

  return {
    provide: {
      api: repositories,
    },
  }
})
